exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 768px) {\n  .selection_sub_title__1JSMC {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 2px 0; }\n    .selection_sub_title__1JSMC:hover, .selection_sub_title__1JSMC:focus {\n      border-bottom: 1px solid blue;\n      cursor: pointer; }\n  .selection_selected__1zGUv {\n    border-bottom: 1px solid blue; }\n  .selection_title__1MVBf {\n    font-size: .8rem;\n    padding: 0 .5rem; } }\n\n@media screen and (max-width: 425px) {\n  .selection_title__1MVBf {\n    font-size: .5rem; } }\n", ""]);

// Exports
exports.locals = {
	"sub_title": "selection_sub_title__1JSMC",
	"selected": "selection_selected__1zGUv",
	"title": "selection_title__1MVBf"
};